// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Advanced CSS Features for S-CUBUS Website */
/* Modern CSS Grid, Flexbox, Animations, and Micro-interactions */

/* ===== CSS GRID LAYOUTS ===== */

/* Advanced Grid System */
.grid-container {
  display: grid;
  gap: var(--grid-gap);
  width: 100%;
}

/* Responsive Grid Layouts */
.grid-auto-fit {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-6);
}

.grid-auto-fill {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--spacing-4);
}

/* Complex Grid Layouts */
.grid-complex {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 
    "header header header"
    "sidebar main aside"
    "footer footer footer";
  gap: var(--spacing-6);
  min-height: 100vh;
}

.grid-header { grid-area: header; }
.grid-sidebar { grid-area: sidebar; }
.grid-main { grid-area: main; }
.grid-aside { grid-area: aside; }
.grid-footer { grid-area: footer; }

/* Masonry-like Grid */
.grid-masonry {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: masonry;
  gap: var(--spacing-6);
}

/* Card Grid with Subgrid */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-8);
}

.card-grid-item {
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: var(--color-surface);
  border-radius: var(--radius-xl);
  overflow: hidden;
  transition: var(--transition-all);
  border: 1px solid var(--color-border);
}

.card-grid-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: var(--shadow-xl);
  border-color: var(--color-primary);
}

/* ===== ADVANCED FLEXBOX LAYOUTS ===== */

/* Flexible Navigation */
.flex-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-4);
}

.flex-nav-items {
  display: flex;
  align-items: center;
  gap: var(--spacing-6);
  flex: 1;
}

.flex-nav-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  flex-shrink: 0;
}

/* Flexible Card Layouts */
.flex-cards {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-6);
  justify-content: center;
}

.flex-card {
  flex: 1 1 300px;
  max-width: 400px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
}

.flex-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Centered Content with Flex */
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.flex-center-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: var(--spacing-6);
}

/* Flexible Form Layouts */
.flex-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.flex-form-row {
  display: flex;
  gap: var(--spacing-4);
  flex-wrap: wrap;
}

.flex-form-field {
  flex: 1;
  min-width: 200px;
}

/* ===== ADVANCED ANIMATIONS ===== */

/* Keyframe Animations */
@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
  20%, 40%, 60%, 80% { transform: translateX(10px); }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 5px var(--color-primary);
  }
  50% {
    box-shadow: 0 0 20px var(--color-primary), 0 0 30px var(--color-primary);
  }
}

/* Animation Classes */
.animate-slide-in-left {
  animation: slideInFromLeft 0.6s ease-out forwards;
}

.animate-slide-in-right {
  animation: slideInFromRight 0.6s ease-out forwards;
}

.animate-slide-in-top {
  animation: slideInFromTop 0.6s ease-out forwards;
}

.animate-slide-in-bottom {
  animation: slideInFromBottom 0.6s ease-out forwards;
}

.animate-fade-in-scale {
  animation: fadeInScale 0.6s ease-out forwards;
}

.animate-bounce-in {
  animation: bounceIn 0.8s ease-out forwards;
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

.animate-shake {
  animation: shake 0.5s ease-in-out;
}

.animate-rotate {
  animation: rotate 2s linear infinite;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-glow {
  animation: glow 2s ease-in-out infinite;
}

/* Staggered Animations */
.stagger-children > * {
  opacity: 0;
  transform: translateY(30px);
  animation: slideInFromBottom 0.6s ease-out forwards;
}

.stagger-children > *:nth-child(1) { animation-delay: 0.1s; }
.stagger-children > *:nth-child(2) { animation-delay: 0.2s; }
.stagger-children > *:nth-child(3) { animation-delay: 0.3s; }
.stagger-children > *:nth-child(4) { animation-delay: 0.4s; }
.stagger-children > *:nth-child(5) { animation-delay: 0.5s; }
.stagger-children > *:nth-child(6) { animation-delay: 0.6s; }

/* ===== HOVER EFFECTS & MICRO-INTERACTIONS ===== */

/* Button Hover Effects */
.btn-hover-lift {
  transition: var(--transition-all);
}

.btn-hover-lift:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-hover-scale {
  transition: var(--transition-all);
}

.btn-hover-scale:hover {
  transform: scale(1.05);
}

.btn-hover-glow {
  transition: var(--transition-all);
  position: relative;
  overflow: hidden;
}

.btn-hover-glow::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn-hover-glow:hover::before {
  left: 100%;
}

/* Card Hover Effects */
.card-hover-lift {
  transition: var(--transition-all);
  cursor: pointer;
}

.card-hover-lift:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-2xl);
}

.card-hover-tilt {
  transition: var(--transition-all);
  cursor: pointer;
}

.card-hover-tilt:hover {
  transform: perspective(1000px) rotateX(5deg) rotateY(5deg);
}

.card-hover-zoom {
  overflow: hidden;
  transition: var(--transition-all);
}

.card-hover-zoom img {
  transition: var(--transition-all);
}

.card-hover-zoom:hover img {
  transform: scale(1.1);
}

/* Interactive Elements */
.interactive-element {
  position: relative;
  transition: var(--transition-all);
  cursor: pointer;
}

.interactive-element::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(var(--color-primary-rgb), 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s, height 0.3s;
}

.interactive-element:hover::after {
  width: 100%;
  height: 100%;
}

/* Ripple Effect */
.ripple {
  position: relative;
  overflow: hidden;
}

.ripple::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(var(--color-primary-rgb), 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.ripple:active::before {
  width: 300px;
  height: 300px;
}

/* Loading Animations */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: rotate 1s linear infinite;
}

.loading-dots {
  display: flex;
  gap: var(--spacing-2);
}

.loading-dot {
  width: 8px;
  height: 8px;
  background: var(--color-primary);
  border-radius: 50%;
  animation: pulse 1.4s ease-in-out infinite both;
}

.loading-dot:nth-child(1) { animation-delay: -0.32s; }
.loading-dot:nth-child(2) { animation-delay: -0.16s; }
.loading-dot:nth-child(3) { animation-delay: 0s; }

/* Progress Indicators */
.progress-bar {
  width: 100%;
  height: 8px;
  background: var(--color-border);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
  border-radius: var(--radius-full);
  transition: width 0.3s ease;
  position: relative;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* ===== ADVANCED LAYOUT PATTERNS ===== */

/* Sticky Elements */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  background: var(--color-background);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--color-border);
}

.sticky-sidebar {
  position: sticky;
  top: var(--spacing-20);
  height: fit-content;
}

/* Parallax Sections */
.parallax-container {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  perspective: 1px;
}

.parallax-element {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.parallax-back {
  transform: translateZ(-1px) scale(2);
}

.parallax-base {
  transform: translateZ(0);
}

/* Modal and Overlay Effects */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: var(--z-modal-backdrop);
  opacity: 0;
  visibility: hidden;
  transition: var(--transition-all);
}

.modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  background: var(--color-background);
  border-radius: var(--radius-xl);
  padding: var(--spacing-8);
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  z-index: var(--z-modal);
  transition: var(--transition-all);
}

.modal-overlay.active .modal-content {
  transform: translate(-50%, -50%) scale(1);
}

/* ===== RESPONSIVE ENHANCEMENTS ===== */

/* Container Queries (when supported) */
@container (min-width: 400px) {
  .container-responsive {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

/* Clamp for Responsive Typography */
.responsive-text-xl {
  font-size: clamp(1.5rem, 4vw, 3rem);
}

.responsive-text-lg {
  font-size: clamp(1.25rem, 3vw, 2rem);
}

.responsive-text-base {
  font-size: clamp(1rem, 2vw, 1.25rem);
}

/* Responsive Spacing */
.responsive-padding {
  padding: clamp(1rem, 5vw, 3rem);
}

.responsive-margin {
  margin: clamp(0.5rem, 3vw, 2rem);
}

/* ===== ACCESSIBILITY ENHANCEMENTS ===== */

/* Focus Indicators */
.focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-base);
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .parallax-element {
    transform: none !important;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .card-grid-item,
  .interactive-element,
  .modal-content {
    border: 2px solid;
  }
  
  .btn-hover-glow::before {
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent);
  }
}

/* ===== UTILITY CLASSES ===== */

/* Transform Utilities */
.transform-gpu {
  transform: translateZ(0);
  will-change: transform;
}

.backface-hidden {
  backface-visibility: hidden;
}

/* Overflow Utilities */
.overflow-hidden { overflow: hidden; }
.overflow-scroll { overflow: scroll; }
.overflow-auto { overflow: auto; }

/* Position Utilities */
.relative { position: relative; }
.absolute { position: absolute; }
.fixed { position: fixed; }
.sticky { position: sticky; }

/* Z-Index Utilities */
.z-0 { z-index: 0; }
.z-10 { z-index: 10; }
.z-20 { z-index: 20; }
.z-30 { z-index: 30; }
.z-40 { z-index: 40; }
.z-50 { z-index: 50; }

/* Flexbox Utilities */
.flex { display: flex; }
.inline-flex { display: inline-flex; }
.flex-col { flex-direction: column; }
.flex-row { flex-direction: row; }
.flex-wrap { flex-wrap: wrap; }
.flex-nowrap { flex-wrap: nowrap; }
.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }
.items-start { align-items: flex-start; }
.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.items-stretch { align-items: stretch; }

/* Grid Utilities */
.grid { display: grid; }
.inline-grid { display: inline-grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }

/* Gap Utilities */
.gap-1 { gap: var(--spacing-1); }
.gap-2 { gap: var(--spacing-2); }
.gap-3 { gap: var(--spacing-3); }
.gap-4 { gap: var(--spacing-4); }
.gap-6 { gap: var(--spacing-6); }
.gap-8 { gap: var(--spacing-8); }

/* ===== PRINT STYLES ===== */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-break-before {
    break-before: page;
  }
  
  .print-break-after {
    break-after: page;
  }
  
  .print-break-inside-avoid {
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/frontend/styles/advanced.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,iEAAiE;;AAEjE,iCAAiC;;AAEjC,yBAAyB;AACzB;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC;;;0BAGwB;EACxB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,eAAe,iBAAiB,EAAE;AAClC,gBAAgB,kBAAkB,EAAE;AACpC,aAAa,eAAe,EAAE;AAC9B,cAAc,gBAAgB,EAAE;AAChC,eAAe,iBAAiB,EAAE;;AAElC,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,yCAAyC;;AAEzC,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,oCAAoC;;AAEpC,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,4BAA4B,EAAE;EACxD,qBAAqB,2BAA2B,EAAE;AACpD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,wEAAwE;EAC1E;AACF;;AAEA,sBAAsB;AACtB;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;;AAE5D,mDAAmD;;AAEnD,yBAAyB;AACzB;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE;;AAEjD,wBAAwB;AACxB;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gFAAgF;EAChF,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mFAAmF;EACnF,8BAA8B;AAChC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,yCAAyC;;AAEzC,oBAAoB;AACpB;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wCAAwC;;AAExC,uCAAuC;AACvC;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2CAA2C;;AAE3C,qBAAqB;AACrB;EACE,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,mFAAmF;EACrF;AACF;;AAEA,gCAAgC;;AAEhC,wBAAwB;AACxB;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,cAAc,EAAE;;AAEjC,uBAAuB;AACvB,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;AAChC,SAAS,eAAe,EAAE;AAC1B,UAAU,gBAAgB,EAAE;;AAE5B,sBAAsB;AACtB,OAAO,UAAU,EAAE;AACnB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;;AAErB,sBAAsB;AACtB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,YAAY,sBAAsB,EAAE;AACpC,YAAY,mBAAmB,EAAE;AACjC,aAAa,eAAe,EAAE;AAC9B,eAAe,iBAAiB,EAAE;AAClC,iBAAiB,2BAA2B,EAAE;AAC9C,kBAAkB,uBAAuB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,mBAAmB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,iBAAiB,oBAAoB,EAAE;;AAEvC,mBAAmB;AACnB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;;AAEnE,kBAAkB;AAClB,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;;AAEhC,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Advanced CSS Features for S-CUBUS Website */\n/* Modern CSS Grid, Flexbox, Animations, and Micro-interactions */\n\n/* ===== CSS GRID LAYOUTS ===== */\n\n/* Advanced Grid System */\n.grid-container {\n  display: grid;\n  gap: var(--grid-gap);\n  width: 100%;\n}\n\n/* Responsive Grid Layouts */\n.grid-auto-fit {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-6);\n}\n\n.grid-auto-fill {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: var(--spacing-4);\n}\n\n/* Complex Grid Layouts */\n.grid-complex {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  grid-template-rows: auto 1fr auto;\n  grid-template-areas: \n    \"header header header\"\n    \"sidebar main aside\"\n    \"footer footer footer\";\n  gap: var(--spacing-6);\n  min-height: 100vh;\n}\n\n.grid-header { grid-area: header; }\n.grid-sidebar { grid-area: sidebar; }\n.grid-main { grid-area: main; }\n.grid-aside { grid-area: aside; }\n.grid-footer { grid-area: footer; }\n\n/* Masonry-like Grid */\n.grid-masonry {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  grid-auto-rows: masonry;\n  gap: var(--spacing-6);\n}\n\n/* Card Grid with Subgrid */\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-8);\n}\n\n.card-grid-item {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  background: var(--color-surface);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  transition: var(--transition-all);\n  border: 1px solid var(--color-border);\n}\n\n.card-grid-item:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: var(--shadow-xl);\n  border-color: var(--color-primary);\n}\n\n/* ===== ADVANCED FLEXBOX LAYOUTS ===== */\n\n/* Flexible Navigation */\n.flex-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--spacing-4);\n}\n\n.flex-nav-items {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-6);\n  flex: 1;\n}\n\n.flex-nav-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-4);\n  flex-shrink: 0;\n}\n\n/* Flexible Card Layouts */\n.flex-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-6);\n  justify-content: center;\n}\n\n.flex-card {\n  flex: 1 1 300px;\n  max-width: 400px;\n  min-width: 280px;\n  display: flex;\n  flex-direction: column;\n}\n\n.flex-card-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* Centered Content with Flex */\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.flex-center-column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: var(--spacing-6);\n}\n\n/* Flexible Form Layouts */\n.flex-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n}\n\n.flex-form-row {\n  display: flex;\n  gap: var(--spacing-4);\n  flex-wrap: wrap;\n}\n\n.flex-form-field {\n  flex: 1;\n  min-width: 200px;\n}\n\n/* ===== ADVANCED ANIMATIONS ===== */\n\n/* Keyframe Animations */\n@keyframes slideInFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInFromBottom {\n  from {\n    opacity: 0;\n    transform: translateY(100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }\n  20%, 40%, 60%, 80% { transform: translateX(10px); }\n}\n\n@keyframes rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n}\n\n@keyframes glow {\n  0%, 100% {\n    box-shadow: 0 0 5px var(--color-primary);\n  }\n  50% {\n    box-shadow: 0 0 20px var(--color-primary), 0 0 30px var(--color-primary);\n  }\n}\n\n/* Animation Classes */\n.animate-slide-in-left {\n  animation: slideInFromLeft 0.6s ease-out forwards;\n}\n\n.animate-slide-in-right {\n  animation: slideInFromRight 0.6s ease-out forwards;\n}\n\n.animate-slide-in-top {\n  animation: slideInFromTop 0.6s ease-out forwards;\n}\n\n.animate-slide-in-bottom {\n  animation: slideInFromBottom 0.6s ease-out forwards;\n}\n\n.animate-fade-in-scale {\n  animation: fadeInScale 0.6s ease-out forwards;\n}\n\n.animate-bounce-in {\n  animation: bounceIn 0.8s ease-out forwards;\n}\n\n.animate-pulse {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.animate-shake {\n  animation: shake 0.5s ease-in-out;\n}\n\n.animate-rotate {\n  animation: rotate 2s linear infinite;\n}\n\n.animate-float {\n  animation: float 3s ease-in-out infinite;\n}\n\n.animate-glow {\n  animation: glow 2s ease-in-out infinite;\n}\n\n/* Staggered Animations */\n.stagger-children > * {\n  opacity: 0;\n  transform: translateY(30px);\n  animation: slideInFromBottom 0.6s ease-out forwards;\n}\n\n.stagger-children > *:nth-child(1) { animation-delay: 0.1s; }\n.stagger-children > *:nth-child(2) { animation-delay: 0.2s; }\n.stagger-children > *:nth-child(3) { animation-delay: 0.3s; }\n.stagger-children > *:nth-child(4) { animation-delay: 0.4s; }\n.stagger-children > *:nth-child(5) { animation-delay: 0.5s; }\n.stagger-children > *:nth-child(6) { animation-delay: 0.6s; }\n\n/* ===== HOVER EFFECTS & MICRO-INTERACTIONS ===== */\n\n/* Button Hover Effects */\n.btn-hover-lift {\n  transition: var(--transition-all);\n}\n\n.btn-hover-lift:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-hover-scale {\n  transition: var(--transition-all);\n}\n\n.btn-hover-scale:hover {\n  transform: scale(1.05);\n}\n\n.btn-hover-glow {\n  transition: var(--transition-all);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-hover-glow::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.5s;\n}\n\n.btn-hover-glow:hover::before {\n  left: 100%;\n}\n\n/* Card Hover Effects */\n.card-hover-lift {\n  transition: var(--transition-all);\n  cursor: pointer;\n}\n\n.card-hover-lift:hover {\n  transform: translateY(-10px);\n  box-shadow: var(--shadow-2xl);\n}\n\n.card-hover-tilt {\n  transition: var(--transition-all);\n  cursor: pointer;\n}\n\n.card-hover-tilt:hover {\n  transform: perspective(1000px) rotateX(5deg) rotateY(5deg);\n}\n\n.card-hover-zoom {\n  overflow: hidden;\n  transition: var(--transition-all);\n}\n\n.card-hover-zoom img {\n  transition: var(--transition-all);\n}\n\n.card-hover-zoom:hover img {\n  transform: scale(1.1);\n}\n\n/* Interactive Elements */\n.interactive-element {\n  position: relative;\n  transition: var(--transition-all);\n  cursor: pointer;\n}\n\n.interactive-element::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: rgba(var(--color-primary-rgb), 0.1);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s, height 0.3s;\n}\n\n.interactive-element:hover::after {\n  width: 100%;\n  height: 100%;\n}\n\n/* Ripple Effect */\n.ripple {\n  position: relative;\n  overflow: hidden;\n}\n\n.ripple::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(var(--color-primary-rgb), 0.3);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.ripple:active::before {\n  width: 300px;\n  height: 300px;\n}\n\n/* Loading Animations */\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--color-border);\n  border-top: 4px solid var(--color-primary);\n  border-radius: 50%;\n  animation: rotate 1s linear infinite;\n}\n\n.loading-dots {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.loading-dot {\n  width: 8px;\n  height: 8px;\n  background: var(--color-primary);\n  border-radius: 50%;\n  animation: pulse 1.4s ease-in-out infinite both;\n}\n\n.loading-dot:nth-child(1) { animation-delay: -0.32s; }\n.loading-dot:nth-child(2) { animation-delay: -0.16s; }\n.loading-dot:nth-child(3) { animation-delay: 0s; }\n\n/* Progress Indicators */\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: var(--color-border);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));\n  border-radius: var(--radius-full);\n  transition: width 0.3s ease;\n  position: relative;\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n/* ===== ADVANCED LAYOUT PATTERNS ===== */\n\n/* Sticky Elements */\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: var(--z-sticky);\n  background: var(--color-background);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.sticky-sidebar {\n  position: sticky;\n  top: var(--spacing-20);\n  height: fit-content;\n}\n\n/* Parallax Sections */\n.parallax-container {\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  perspective: 1px;\n}\n\n.parallax-element {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.parallax-back {\n  transform: translateZ(-1px) scale(2);\n}\n\n.parallax-base {\n  transform: translateZ(0);\n}\n\n/* Modal and Overlay Effects */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  z-index: var(--z-modal-backdrop);\n  opacity: 0;\n  visibility: hidden;\n  transition: var(--transition-all);\n}\n\n.modal-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-content {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.8);\n  background: var(--color-background);\n  border-radius: var(--radius-xl);\n  padding: var(--spacing-8);\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: auto;\n  z-index: var(--z-modal);\n  transition: var(--transition-all);\n}\n\n.modal-overlay.active .modal-content {\n  transform: translate(-50%, -50%) scale(1);\n}\n\n/* ===== RESPONSIVE ENHANCEMENTS ===== */\n\n/* Container Queries (when supported) */\n@container (min-width: 400px) {\n  .container-responsive {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* Clamp for Responsive Typography */\n.responsive-text-xl {\n  font-size: clamp(1.5rem, 4vw, 3rem);\n}\n\n.responsive-text-lg {\n  font-size: clamp(1.25rem, 3vw, 2rem);\n}\n\n.responsive-text-base {\n  font-size: clamp(1rem, 2vw, 1.25rem);\n}\n\n/* Responsive Spacing */\n.responsive-padding {\n  padding: clamp(1rem, 5vw, 3rem);\n}\n\n.responsive-margin {\n  margin: clamp(0.5rem, 3vw, 2rem);\n}\n\n/* ===== ACCESSIBILITY ENHANCEMENTS ===== */\n\n/* Focus Indicators */\n.focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius-base);\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n  \n  .parallax-element {\n    transform: none !important;\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .card-grid-item,\n  .interactive-element,\n  .modal-content {\n    border: 2px solid;\n  }\n  \n  .btn-hover-glow::before {\n    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent);\n  }\n}\n\n/* ===== UTILITY CLASSES ===== */\n\n/* Transform Utilities */\n.transform-gpu {\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.backface-hidden {\n  backface-visibility: hidden;\n}\n\n/* Overflow Utilities */\n.overflow-hidden { overflow: hidden; }\n.overflow-scroll { overflow: scroll; }\n.overflow-auto { overflow: auto; }\n\n/* Position Utilities */\n.relative { position: relative; }\n.absolute { position: absolute; }\n.fixed { position: fixed; }\n.sticky { position: sticky; }\n\n/* Z-Index Utilities */\n.z-0 { z-index: 0; }\n.z-10 { z-index: 10; }\n.z-20 { z-index: 20; }\n.z-30 { z-index: 30; }\n.z-40 { z-index: 40; }\n.z-50 { z-index: 50; }\n\n/* Flexbox Utilities */\n.flex { display: flex; }\n.inline-flex { display: inline-flex; }\n.flex-col { flex-direction: column; }\n.flex-row { flex-direction: row; }\n.flex-wrap { flex-wrap: wrap; }\n.flex-nowrap { flex-wrap: nowrap; }\n.justify-start { justify-content: flex-start; }\n.justify-center { justify-content: center; }\n.justify-end { justify-content: flex-end; }\n.justify-between { justify-content: space-between; }\n.justify-around { justify-content: space-around; }\n.items-start { align-items: flex-start; }\n.items-center { align-items: center; }\n.items-end { align-items: flex-end; }\n.items-stretch { align-items: stretch; }\n\n/* Grid Utilities */\n.grid { display: grid; }\n.inline-grid { display: inline-grid; }\n.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }\n\n/* Gap Utilities */\n.gap-1 { gap: var(--spacing-1); }\n.gap-2 { gap: var(--spacing-2); }\n.gap-3 { gap: var(--spacing-3); }\n.gap-4 { gap: var(--spacing-4); }\n.gap-6 { gap: var(--spacing-6); }\n.gap-8 { gap: var(--spacing-8); }\n\n/* ===== PRINT STYLES ===== */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-break-before {\n    break-before: page;\n  }\n  \n  .print-break-after {\n    break-after: page;\n  }\n  \n  .print-break-inside-avoid {\n    break-inside: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
